import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const WrongIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 10.2365L6.41004 4.64648L4.64648 6.41004L10.2365 12L4.64648 17.59L6.41004 19.3536L12 13.7636L17.59 19.3536L19.3536 17.59L13.7636 12L19.3536 6.41004L17.59 4.64648L12 10.2365Z"
          fill="#FF707D"
        />
      </svg>
    )
  },
)
